export const MINUTE_MS = 60 * 1000;

export const HOUR_MS = 60 * MINUTE_MS;

export const DAY_MS = 24 * HOUR_MS;

export const MINUTE_S = 60;

export const HOUR_S = 60 * MINUTE_S;

export const DAY_S = 24 * HOUR_S;
